import { useBusiness } from 'hooks/business/useBusiness';

export const useFooter = () => {
  const { address, showAddress } = useBusiness();
  const termsOfServiceUrl = 'https://glossgenius.com/terms';
  const privacyPolicyUrl = 'https://glossgenius.com/privacy';
  const addressLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address,
  )}`;

  return {
    address,
    addressLink,
    privacyPolicyUrl,
    showAddress,
    termsOfServiceUrl,
  };
};
